// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_uo-0";
export var checkoutRateBadgeLink = "_uo-1";